import { render, staticRenderFns } from "./BatchEditStockDialog.vue?vue&type=template&id=5ed44249"
import script from "./BatchEditStockDialog.vue?vue&type=script&lang=js"
export * from "./BatchEditStockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports